module.exports = __webpack_public_path__ + "img/hn.76697280.jpg";